import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";
import { PageHeader, Empty, SortTh, useLocalSort, istDT } from "../components/common";

export default function Approvals() {
  const { can, user } = useAuth();
  const [status, setStatus] = useState("pending");
  const [items, setItems] = useState([]);
  const [sorted, sort] = useLocalSort(items, "created_at", -1);
  const load = useCallback(() => api.get("/approvals", { params: { status } }).then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))), [status]);
  useEffect(() => { load(); }, [load]);
  const decide = (a, decision) => api.post(`/approvals/${a.approval_id}/decide`, { decision }).then(() => { toast.success(`Request ${decision}d`); load(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div>
      <PageHeader eyebrow="Governance" title="Approvals" desc="Bulk lead reassignments wait here for a manager or founder. Nobody can approve their own request.">
        {["pending", "approved", "rejected", "all"].map((s) => <button key={s} data-testid={`approvals-filter-${s}`} onClick={() => setStatus(s)} className={`border h-9 px-3 text-sm capitalize ${status === s ? "border-primary text-primary" : ""}`}>{s}</button>)}
      </PageHeader>
      {!items.length ? <Empty text="No approval requests." /> : (
        <div className="ax-panel ax-scroll ax-freeze"><table className="ax-table w-full" data-testid="approvals-table">
          <thead><tr>{[["created_at", "Requested"], ["requested_by_name", "By"], [null, "Type"], [null, "Leads"], [null, "New owner"], [null, "Reason"], ["status", "Status"]].map(([k, l]) => <SortTh key={l} k={k} label={l} sort={sort} />)}<th /></tr></thead>
          <tbody>{sorted.map((a) => (
            <tr key={a.approval_id} data-testid={`approval-row-${a.approval_id}`}>
              <td className="num text-xs">{istDT(a.created_at)}</td><td>{a.requested_by_name}</td><td>Bulk reassign</td>
              <td className="num">{a.payload.lead_ids.length}</td><td>{a.payload.new_owner}</td><td className="text-xs max-w-xs">{a.reason}</td>
              <td className="text-xs">{a.status}{a.decided_by ? ` · ${a.decided_by}` : ""}</td>
              <td>{a.status === "pending" && can("sales", "approve") && a.requested_by !== user.user_id && (
                <div className="flex gap-1">
                  <button data-testid={`approval-approve-${a.approval_id}`} onClick={() => decide(a, "approve")} className="bg-primary text-primary-foreground text-xs px-2 py-1">Approve</button>
                  <button data-testid={`approval-reject-${a.approval_id}`} onClick={() => decide(a, "reject")} className="border text-xs px-2 py-1">Reject</button>
                </div>)}</td>
            </tr>
          ))}</tbody></table></div>
      )}
    </div>
  );
}
